import { render, staticRenderFns } from "./WidgetsContainer.global.vue?vue&type=template&id=318a3d74&lang=pug&"
import script from "./WidgetsContainer.global.vue?vue&type=script&lang=ts&"
export * from "./WidgetsContainer.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports